import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/faq/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/hero/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoModal"] */ "/var/www/basic-traning-frontend/components/partials/modal/home-page-video-modal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/modal/notify-me/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/basic-traning-frontend/components/partials/recommend-us/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/basic-traning-frontend/node_modules/next/dist/client/app-dir/link.js");
